import { render } from "./ComCommentButton.vue?vue&type=template&id=19c0db2e&ts=true"
import script from "./ComCommentButton.vue?vue&type=script&lang=ts"
export * from "./ComCommentButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__